import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";

import Tooltip from "../../shared/components/Tooltip";
import VirtualizedTable from "../../shared/components/VirtualizedTable";
import {
  LOGS_TABLE_ROW_HEIGHT,
  MIN_WIDTH_AUTHOR,
  MIN_WIDTH_DATE,
  MIN_WIDTH_DESCRIPTION,
  MIN_WIDTH_EVENT,
  MIN_WIDTH_TARGET
} from "../constants";

const columns = [
  { label: "Date", key: "date", minWidth: MIN_WIDTH_DATE },
  { label: "Author", key: "author", minWidth: MIN_WIDTH_AUTHOR },
  { label: "Event", key: "event", minWidth: MIN_WIDTH_EVENT },
  { label: "Target", key: "activity", minWidth: MIN_WIDTH_TARGET },
  { label: "Description", key: "description", minWidth: MIN_WIDTH_DESCRIPTION }
];

class LogsTable extends Component {
  static headerRenderer = column => (
    <div className="p-table__header-cell">{column.label}</div>
  );

  static cellRenderer = (column, log) => {
    let cellData = log[column.key];

    if (column.key === "description" && log.message) {
      cellData = (
        <Fragment>
          {log.message}
          <Tooltip
            position="top-right"
            message={log.description}
            style={{
              width: "30rem",
              whiteSpace: "normal"
            }}
          >
            <i className="p-icon--information p-icon__text" />
          </Tooltip>
        </Fragment>
      );
    }

    if (cellData.row1 && cellData.row2) {
      return (
        <div className="p-logs-table__cell">
          <div>{cellData.row1}</div>
          <div className="p-muted-text">{cellData.row2}</div>
        </div>
      );
    }
    return (
      <div className="p-logs-table__cell">{cellData.label || cellData}</div>
    );
  };

  render() {
    const { logs } = this.props;

    return (
      <div className="p-logs-table">
        <VirtualizedTable
          cellRenderer={this.constructor.cellRenderer}
          columns={columns}
          defaultRowHeight={LOGS_TABLE_ROW_HEIGHT}
          headerRenderer={this.constructor.headerRenderer}
          rows={logs}
        />
      </div>
    );
  }
}

LogsTable.propTypes = {
  logs: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default LogsTable;
